import { config } from "./config"
import { useDispatch, useSelector } from "react-redux"
import { Suspense, useEffect } from "react"
import { Outlet, useLocation, useNavigate, matchRoutes, useMatch, useResolvedPath, useMatches, useLoaderData } from "react-router-dom"

import { deviceApi } from "./modules/identity/reducers/identitySlice"

import Maintanance from "./modules/user/views/Maintanance"
import FullLayout from "./layouts/FullLayout"
import Spinner from "./layouts/layout-components/spinner/Spinner"

function Root() {
    const mantainance = config.mantainance;
    const status = useSelector((state) => state.identityReducer.status)
    const identity = useSelector((state) => state.identityReducer.identity)
    const uid = useSelector((state) => {
        return state.identityReducer.identity ? state.identityReducer.identity.uid : null
    });

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(deviceApi.initDevice());
    }, [dispatch]);

    return (
        <>
        { mantainance 
            ? <Maintanance />
            : <Suspense fallback={<Spinner />}>
                {(
                    status === 'device/succeeded' || 
                    status === 'login/succeeded' || status === 'login/rejected' ||
                    status === 'logout/succeeded' || status === 'logout/rejected' ||
                    status === 'recovery/succeeded' ||
                    identity
                ) 
                    ? uid 
                        ? <FullLayout /> 
                        : <Outlet />
                    : <Spinner />
                }
            </Suspense>
        }   
        </>
    );
}

export default Root;